import { Button } from '@/components/ui/button';
import { useRecommendationOptions } from '@/hooks/use-product-recommendations';
import type { RecommendationClient, RecommendationGroup } from '@/types';

export function RecommendationGroupProducts({ client, scope, group, onSelect }: { client: RecommendationClient; scope: string; group: RecommendationGroup; onSelect(id: string): void }) {
  const rows = useRecommendationOptions(client, scope, 'productIds', '', true, group);
  return <div className='space-y-1 border-l border-gray-300 pl-5'>
    {rows.loading && <p className='p-2 text-xs text-gray-800'>Loading products…</p>}
    {rows.error && <p role='alert' className='p-2 text-xs text-red-600'>{rows.error}<Button variant='ghost' onClick={rows.retry}>Retry products</Button></p>}
    {!rows.loading && !rows.error && !rows.options.length && <p className='p-2 text-xs text-gray-800'>No products in this group.</p>}
    {rows.options.map((row) => <button type='button' key={row.id} onClick={() => onSelect(row.id)} className='flex h-12 w-full cursor-pointer items-center gap-2.5 rounded px-2 text-left text-sm text-ink hover:bg-gray-50'>
      {row.imageUrl && <img src={row.imageUrl} alt='' className='size-10 rounded-xl object-cover' />}<span>{row.label}</span>
    </button>)}
    {rows.nextCursor && <Button variant='ghost' disabled={rows.busy} onClick={() => void rows.loadMore()}>Load more products</Button>}
  </div>;
}
